import React, { useState } from 'react';
import FormResponseMessage from "../../formResponseMessage";
import {
  CANADA_COUNTRY,
  COUNTRY,
  CURRENCY,
  CURRENCY_CODE
} from '../../../helpers/variables';
import {FormGroup, InfoTooltip} from 'arag-ui-lib';
import InfoLabel from '../../infoLabel';
import FormGroupTextArea from "../../formGroupTextArea";
import { PREMIUM_SETTING_NOTES_AREA_INFO_MESSAGE, PREMIUM_SETTING_COMMENT_AREA_INFO_MESSAGE } from '../../../helpers/constants';

const Step5 = (props) => {
  const [infoStateNotes, setInfoStateNotes] = useState(false); 
  const [infoStateComments, setInfoStateComments] = useState(false); 
   
    if (props.currentStep !== 5)
        return null;
    return (
        <div >
            <p className="premiumSettingsWizard-step-message">{props.stepMessage}</p>
          <FormGroup
            labelSize="col-sm-3"
            inputSize="col-sm-7"
            label="Limit of Indemnity"
            variant={'currency'}
            inputProps={{
              required: true,
              onChange: ((evt) => {  props.changeStoreSettings(evt.target.name, evt.target.value.replace(/[^0-9.]/g, ''))}),
              name: "limitOfIndemnity",
              value: props.limitOfIndemnity,
              disabledDropdown: true,
              handleOptionSelect: () => {},
              menuOptions: [
                { sign: CURRENCY, code: CURRENCY_CODE },
              ],
              selectedCurrency: {
                sign: CURRENCY,
                code: CURRENCY_CODE,
              },
            }}
          />
        <FormGroupTextArea
          centerWrapper="col-md-7 formGroupTextArea-wrapper"
          Required={false}
          Label="Notes"
          Name="notes"
          key="notes"         
          Value={props.notes}
          HandleInputChange={(name, value) => props.changeStoreSettings(name, value)}
          RightWrapper='infoBoxComment'
          rightData={<InfoLabel
            Value={PREMIUM_SETTING_NOTES_AREA_INFO_MESSAGE}
            infoState={infoStateNotes}
            onMouseOverHandler={() => setInfoStateNotes(!infoStateNotes)}
          />}
        />

        <FormGroupTextArea
          centerWrapper="col-md-7 formGroupTextArea-wrapper"
          Required={false}
          Label="Comments"
          Name="comments"
          key="comments"
          Value={props.comments}
          HandleInputChange={(name, value) => props.changeStoreSettings(name, value)}
          RightWrapper='infoBoxComment'
          rightData={<InfoLabel
            Value={PREMIUM_SETTING_COMMENT_AREA_INFO_MESSAGE}
            infoState={infoStateComments}
            onMouseOverHandler={() => setInfoStateComments(!infoStateComments)}
          />}
        />        
            {COUNTRY == CANADA_COUNTRY ? (
                <div>
                    <FormGroup
                        labelSize="col-sm-3"
                        inputSize="col-sm-7"
                        label="Coverage Types"
                        variant="select"
                        inputProps={{
                            onChange: ((evt) => { props.changeStoreSettings(evt.target.name, parseInt(evt.target.value))}),
                            options: [{key: '', label: ''},...props.coveragesOptions.map(c => { return { key: c.id, label: c.name } })],
                            value: props.selectedCoverageType,
                            name: "selectedCoverageType",
                            required: true,
                        }}
                    />
                    <FormGroup
                        labelSize="col-sm-3"
                        inputSize="col-sm-7"
                        label="Deductible"
                        variant="select"
                        inputProps={{
                            onChange: ((evt) => { props.changeStoreSettings(evt.target.name, parseInt(evt.target.value)) }),
                            options: [{key: '', label: ''},...props.deductiblesOptions.map(c => { return { key: c.id, label: c.name } })],
                            value: props.selectedDeductible,
                            name: "selectedDeductible",
                            required: true,
                        }}
                    />
                    <FormGroup
                        labelSize="col-sm-3"
                        inputSize="col-sm-7"
                        label="Endorsements"
                        variant="select"
                        inputProps={{
                            onChange: ((evt) => { props.changeStoreSettings(evt.target.name, parseInt(evt.target.value))}),
                            options:[{key: '', label: ''},...props.endorsementsOptions.map((c,index )=> { return { key: c.id, label: c.name } })],
                            value: props.selectedEndorsement,
                            name: "selectedEndorsement",
                            required: true,
                        }}
                    />
                </div>
            )
            :
             <FormGroup
               labelSize="col-sm-3"
               inputSize="col-sm-7"
               required={false}
               label={'Endorsements'}
               variant="textarea"
               inputProps={{
                 onChange: (evt) => props.changeStoreSettings(evt.target.name,evt.target.value),
                 name: 'endorsements',
                 value: props.endorsements,
                 required: false
               }}
             />
            }
            {!props.isApplicationPremium && (
              <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-7'}
                label={'Valid from'}
                variant={'date'}
                inputProps={{
                  required: true,
                  name: 'validFrom',
                  value: props.validFrom,
                  dateInputProps: {
                    minDate: new Date(),
                    dateFormat: 'dd/MM/yyyy',
                    onChange: (evt) => props.changeStoreSettings('validFrom', evt),
                    autoComplete: 'off',
                    selected: props.validFrom,
                    placeholderText : 'DD/MM/YYYY'
                },
                }}
              />
            )}
            {!props.isApplicationPremium && (props.premiumSettingTypeCustom || props.premiumSettingTypePercentage) && (
                <div>
                  <FormGroup
                  labelSize={'col-sm-3'}
                  inputSize={'col-sm-7'}
                  label={'Valid until'}
                  variant={'date'}
                  inputProps={{
                    required: false,
                    name: 'validUntil',
                    value: props.validUntil,
                    dateInputProps: {
                      minDate:  props.validFrom ? props.validFrom : new Date(),
                      dateFormat: 'dd/MM/yyyy',
                      onChange: (evt) => props.changeStoreSettings('validUntil', evt),
                      autoComplete: 'off',
                      selected: props.validUntil,
                      placeholderText : 'DD/MM/YYYY'
                    },
                  }}
                />
                    <div className={'col-sm-10 col-sm-offset-10'} style={{bottom:'45px',right:'20px'}} >
                        <InfoTooltip
                            text="Custom settings will revert back to default settings AFTER selected valid until date"
                            variant="info"
                            style={{}}
                            miscellaneousCharacter=""
                        />
                    </div>
                </div>
            )}
            {
                props.validationMessageStep5 !== '' ?
                    <FormResponseMessage
                        LeftWrapper="col-sm-3"
                        CenterWrapper="col-sm-7"
                        MessageStyle="formResponseMessage-reject"
                        Message={props.validationMessageStep5}/>
                    :
                    null
            }
        </div>
    )
};

export default Step5;
